import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-sidebar-topbar',
    templateUrl: './sidebar-topbar.component.html',
    standalone: false,
})
export class SidebarTopbarComponent {
    @Input() isExpanded;
}
